(function functionsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('functionService', [
            'restUrlBuilder', function functionService(restUrlBuilder) {

                restUrlBuilder = restUrlBuilder('auth');

                this.getNotInRole = function (roleId) {
                    var params = { NotInRole: roleId };
                    return restUrlBuilder.all('functions')
                                         .get({ params: params });
                };

                this.get = function () {
                    return restUrlBuilder.all('functions')
                                         .get();
                };
            }
        ]);
})();